import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { MainBox } from "../components/mainBox";
import { setBehaviour } from "@portal/redux/reducers/riskLevelReducer";
import { BehaviourData } from "../components/highcharts/behaviourData/BehaviourData";
import { MapBehaviourToIndex, MapIndexToBehaviour } from "./helpers/MapData";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import { ToggleButton } from "@portal/components/atoms/buttons/toggle/ToggleButton";

export const BehaviourPage = ({ pageIndex, centerId, isDefaultLanguage }: IPageProps) => {
  const dispatch = useAppDispatch();
  const behaviour = useAppSelector(state => state.persisted.riskLevel).request.behaviour;
  const [isToggleBoxOpen, setIsToggleBoxOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<number | null>(MapBehaviourToIndex(behaviour));
  const isButtonDisabled = behaviour === null || selectedOption === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_6_A, texts.PAGE_6_B, texts.PAGE_6_C];

  const OnSelectionClick = (selectedOption: number) => {
    setSelectedOption(selectedOption);
    dispatch(setBehaviour(MapIndexToBehaviour(selectedOption)));
  };

  return (
    <>
      <MainBox>
        <Typography variant="Body">{texts.PAGE_6_INFO_HEADER}</Typography>
        <div className="flex mt-2.5">
          <Typography variant="H6">{texts.PAGE_6_SUBHEADER_2}</Typography>
        </div>
        <TextLine />
        <SelectionBoxComponent options={options} selectedOption={selectedOption} onSelectionClick={OnSelectionClick} />
        <ToggleButton
          activeText={texts.PAGE_6_BUTTON_TEXT}
          inActiveText={texts.TEXT_CLOSE}
          expanded={isToggleBoxOpen}
          setExpanded={setIsToggleBoxOpen}
        />
        {isToggleBoxOpen && (
          <div>
            <div className="flex flex-col my-3 border rounded-md w-full p-1 bg-white">
              <HighchartsReact highcharts={Highcharts} options={BehaviourData()} />
            </div>
            <div className="flex mt-1 p-2">
              <Typography variant="Body">{texts.PAGE_6_INFO_TEXT}</Typography>
            </div>
          </div>
        )}
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
